module.exports = __webpack_public_path__ + "static/media/img_5.5087b95a.png";